import { render } from "./DefBuySecondary.vue?vue&type=template&id=862d37ea&scoped=true"
import script from "./DefBuySecondary.vue?vue&type=script&lang=js"
export * from "./DefBuySecondary.vue?vue&type=script&lang=js"

import "./DefBuySecondary.vue?vue&type=style&index=0&id=862d37ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862d37ea"]])

export default __exports__